export default "__VITE_ASSET__DxTxN$NB__"